import { render } from "./config.vue?vue&type=template&id=e4713d24&scoped=true"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"

import "./config.vue?vue&type=style&index=0&id=e4713d24&scoped=true&lang=css"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4713d24"]])

export default __exports__